module.exports = __webpack_public_path__ + "img/pdf-file.d00fb7ee.png";